<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="navigation-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.title }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new m-5"
      :settings="settings"
      :key="$vs.rtl"
    >
      <navigation :data="data" :currentReportId="currentReportId" @closeSidebar="closeSidebar()"/>
    </component>
    
  </vs-sidebar>
</template>

<script>

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import navigation from './navigation.vue'
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    currentReportId: {
      type: Number,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    navigation
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      title : "Navigation"
    };
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods:{
    closeSidebar() {
      this.$emit('closeSidebar')
    }
  }
};
</script>

<style lang="scss" scoped>
.navigation-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 600px;
    max-width: 90vw;
   .vs-sidebar--items {
      overflow-y: auto !important;
    }
  }
}


</style>
